import axios from "@/axios";
import { filterInternalNotes } from "./utils";

export async function getCaseEntities(caseId) {
  const url = `case/${caseId}/entity`;
  const { data } = await axios.get(url);
  return data
}

export async function getChecksLogs(refChecksList = []) {
  const checksPromiseList = refChecksList.map(({ id }) => axios.get(`workflow/${id}/log`));
  const checksResponse = await Promise.all(checksPromiseList);

  return checksResponse
    .map(resp => resp?.data?.data)
    .map((resp, index) => {
        return resp.map(item => ({
            ...item,
            check_name: refChecksList[index]?.check_name,
        }));
    })
    .flat();
}

export async function fetchWorkAllocUsers(caseId) {
  const { data } = await axios.get(`work-allocation/case/${caseId}/users`);
  return data;
}

export async function fetchWorkAllocGroups(caseId) {
  const { data } = await axios.get(`work-allocation/case/${caseId}/groups`);
  return data;
}

export async function fetchMultipleWorkAllocUsers(caseIds) {
  const { data } = await axios.post(`work-allocation/case/multi-case-work-allocation/users`,{case_ids: caseIds});
  return data;
}

export async function fetchMultipleWorkAllocGroups(caseIds) {
  const { data } = await axios.post(`work-allocation/case/multi-case-work-allocation/groups`, {case_ids: caseIds});
  return data;
}

export async function fetchClientUsers(clientId) {
  const { data } = await axios.get(`work-allocation/users/tenant`, {
    params: { client_id: clientId }
  });
  return data;
}

export async function fetchCaseNotesUsers(clientId, caseId) {
  const { data } = await axios.get(`case-notes/users-list/${caseId}/${clientId}`);
  return data;
}

export async function fetchClientList(payload) {
  const { data } = await axios.post(`tenant/clients`, payload);
  return data;
}

export async function fetchActivityHistory(payload, isClient = false) {
  const { data } = await axios.post(`/activity-history`, payload);
  const filteredData = data?.filter(el => !el?.is_deleted) ?? [];
  return isClient ? filterInternalNotes(filteredData) : filteredData;
}
